angular.module('tf.controllers')

    .controller('FarmerSettingsController', ['$scope', '$state', '$stateParams', 'HttpService', 'farmer', 'UrlEncodingService','RenderService','FarmerService','ConfirmExitService','HeaderService','$rootScope','ProjectService','MixpanelService','$timeout','ThumbnailSequence','NotificationService', 'ProjectStorageService','FarmService',
        function ($scope, $state, $stateParams, HttpService, farmer, UrlEncodingService, RenderService, FarmerService, ConfirmExitService, HeaderService, $rootScope, ProjectService, MixpanelService, $timeout, ThumbnailSequence, NotificationService, ProjectStorageService,FarmService) {
            $scope.farmer = angular.copy(farmer);
            $scope.settingsChanged = false;

            $scope.header = (_.isEmpty($scope.farmer)?'New':'Edit')+ ' Farmer';

            setTimeout(function(){$('.modal input').first().focus();},1);

            FarmService.getClusters().then(function(clusters){
                $scope.clusters = clusters;
            });

            $scope.applyUseCluster = function () {
                $scope.farmer.use_cluster = $scope.isUseClusterAllowed();
            };
            $scope.isUseClusterAllowed = function () {
              return !_.isEmpty($scope.farmer.cluster);
            };

            $scope.saveSettings = function() {
                $scope.isWorking = true;
                FarmService.updateFarmer($scope.farmer).then(function(){
                    $scope.$close(true);
                }, function(){
                    $('.settings-bottom-menu .settings-button i.fa-spin').removeClass('fa-spin');
                    $scope.isWorking = false;
                });
            };

            $scope.deleteFarmer = function(){
                NotificationService.confirm("Delete Farmer", "Are you sure?", function(){
                    FarmService.deleteFarmer($scope.farmer.key).then(function(){
                        $scope.$close(true);
                    });
                });
            };

            var unwatch = $scope.$watch('farmer', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatch();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };
        }]);